import React from "react";

import { Text } from "@performyard/py-components";

type Props = {
	children: React.ReactNode;
};

/**
 * Visible page heading used by side-nav-era pages where the legacy sub-nav
 * (which previously provided context) has been removed. Renders the
 * 24px Heading5/Semibold style established for the new side-nav pages.
 */
const PageHeading = ({ children }: Props) => (
	<Text size="heading-5" weight="semi-bold" color="neutral-9">
		{children}
	</Text>
);

export default PageHeading;
